import React from "react";

import { FormSelect } from "../../../forms/FormSelect";
import { IFormUUID } from "../../../models/nominals";
import { IWriteReviewTemplateField } from "../../../models/reviews";
import { useAppDispatch, useAppSelector } from "../../reducers";
import { reviewFormTextChange } from "../reducers";
import { getWriteReviewFormState } from "../selectors";

interface IProps {
    formUUID: IFormUUID;
    name: string;
    field: IWriteReviewTemplateField;
}

export const WriteReviewFormDropdownField = (
    props: IProps,
): React.ReactNode => {
    const dispatch = useAppDispatch();

    const formState = useAppSelector((state) =>
        getWriteReviewFormState(state.reviews, props),
    );

    const value = formState?.valuesText[props.name] ?? "";
    const errors = formState.errors[props.name] ?? [];
    const showErrors = formState.showErrors;

    const onChange = (e: React.FormEvent<HTMLSelectElement>) => {
        dispatch(
            reviewFormTextChange({
                formUUID: props.formUUID,
                fieldName: props.name,
                fieldValue: e.currentTarget.value,
            }),
        );
    };

    const choices = props.field.options.map((option) => {
        return {
            value: option,
            label: option,
        };
    });

    return (
        <FormSelect
            name={props.name}
            required={props.field.is_required}
            label={props.field.name}
            labelPlacement={"static"}
            choices={choices}
            onChange={onChange}
            value={value}
            errors={errors}
            showErrorMessages={showErrors}
        />
    );
};
